import Layout from "../Layout";
import Footer from "../../components/Footer";
import CompanyContainer from "../../containers/CompanyContainer";
import GeneralHeader from "../../components/GeneralHeader";

const CompanyPage = () => {
  return (
    <Layout
      header={<GeneralHeader />}
      center={<CompanyContainer />}
      footer={<Footer />}
    />
  );
}

export default CompanyPage;